module.exports = __webpack_public_path__ + "img/u4660.e04ac1d9.svg";